import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PrijavaKorisnikService {

  constructor(public _http: Http) { }

  provjeri(idVideo:any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'vezes/dohvatiVideo', idVideo)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/prijava-korisnik/prijava-korisnik.service.ts